import {Component, Injector, OnInit} from '@angular/core';
import {BaseNewComponents} from '../../base-new-components';
import { HOME } from '../../../app.constants';

@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.sass']
})
export class NewHeaderComponent extends BaseNewComponents implements OnInit {
  isOpenFloatMenu: boolean;
  showToggleNavbar = true;
  constructor(protected injector: Injector) {
    super(injector);
  }
  logoSizeHeight = '10rem';
  logoSizeWidth = '10rem';

  ngOnInit() {
    this.logoSizeMobile();
  }

  logoSizeMobile() {
    if (this.currentGridSize > 0 && this.currentGridSize <= 340) {
      this.logoSizeWidth = '9rem';
      this.logoSizeHeight = '9rem';
    } else if (this.currentGridSize > 341 && this.currentGridSize <= 411) {
      this.logoSizeWidth = '8rem';
      this.logoSizeHeight = '8rem';
    } else if (this.currentGridSize > 412 && this.currentGridSize <= 479) {
      this.logoSizeWidth = '10rem';
      this.logoSizeHeight = '10rem';
    } else if (this.currentGridSize > 480 && this.currentGridSize <= 540) {
      this.logoSizeWidth = '15rem';
      this.logoSizeHeight = '15rem';
    } else {
      this.logoSizeWidth = '10rem';
      this.logoSizeHeight = '10rem';
    }
  }

  goTo(url: string = '', toggleNavbar: boolean = false) {
    if (toggleNavbar) {
      this.toggleNavbar();
    }
    if (this.isMobile()) {
      this.goToExternalUrl(`${HOME}/${url}`, '_top');
      return;
    }
    this.router.navigate([url]);
  }

  toggleNavbar(type: string = '') {
    this.isOpenFloatMenu = !this.isOpenFloatMenu;
    if (type !== '') {
      this.getUrl(type);
    }
  }

  clickedOutside(): void {
    this.isOpenFloatMenu = false;
  }


  getUrl(type: string) {
    switch (type) {
      case 'hotels':
        this.goToHotels();
        break;
      case 'plans':
        this.goToPlans();
        break;
      default:
        break;
    }
  }
}
